export function handleBisFormSubmit(event, bisForm) {
  event.preventDefault();
  const emailInput = bisForm.querySelector('input[type="email"]');
  const notifyButton = bisForm.querySelector('button');
  const messageContainer = bisForm.querySelector('#bis-message-container');
  const email = emailInput.value;
  
  notifyButton.textContent = "Sending...";
  notifyButton.disabled = true;

  const selectedVariantId = bisForm.dataset.variantId;

  const myHeaders = new Headers({
    "revision": "2024-07-15",
    "Content-Type": "application/json",
    "Accept": "application/json"
  });
  
  const raw = JSON.stringify({
    data: {
      type: "back-in-stock-subscription",
      attributes: {
        channels: ["EMAIL"],
        profile: {
          data: {
            type: "profile",
            attributes: {
              email: email
            }
          }
        }
      },
      relationships: {
        variant: {
          data: {
            type: "catalog-variant",
            id: `$shopify:::$default:::${selectedVariantId}`
          }
        }
      }
    }
  });

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=SFsnHs", requestOptions)
    .then(response => {
      if (response.status === 202) {
        messageContainer.textContent = "Success! You will be notified when the product is back in stock.";
        emailInput.value = "";
      } else {
        messageContainer.textContent = "Error: Please try again.";
      }
      notifyButton.textContent = "Notify Me";
      notifyButton.disabled = false;
    })
    .catch(error => {
      messageContainer.textContent = "Error: Unable to process your request. Please try again later.";
      notifyButton.textContent = "Notify Me";
      notifyButton.disabled = false;
    });
}
